<template>
    <div class="box mt-4">
        <div class="row">
            <div class="col-md-12 m-3">
                <h3> Tours </h3>
            </div>
        </div>
        <div class="row">
        <div class="col-md-12">
            <table class="table" cellspacing="0" cellpadding="0" v-if="accommodation && accommodation.tour_accommodation">
            <thead v-if="accommodation.tour_accommodation.length > 0">
                <tr>
                <th>Tour name</th>
                <th>Tour type</th>
                <th>Tour reference</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="tour_accommodation of accommodation.tour_accommodation" :key="tour_accommodation.id">
                <td>
                    <router-link :to="{ name: 'tour-accommodation', params: { id: tour_accommodation.id }}">
                    {{ tour_accommodation.tour.name }}
                    </router-link>
                </td>
                <td>{{ tour_accommodation.tour.type.slug }}</td>
                <td>{{ tour_accommodation.tour.reference }}</td>
                </tr>
            </tbody>
            </table>
        </div>
        </div>
  </div>
</template>

<script>
export default {
    name: 'AccomodationTours',
    props: {
        accommodation:Object
    },
}
</script>

<style lang="scss" scoped>

</style>